<div class="relative">
  <input
    [(ngModel)]="inputValue"
    (input)="filterItems()"
    (keydown.enter)="addNewItem()"
    (focus)="onFocus()"
    (ngModelChange)="onInputChange($event)"
    (blur)="onBlur()"
    class="w-full p-3 fields mt-2"
    [class.border-red-500]="hasError"
    [class.border-1]="hasError"
    [placeholder]="placeholder"
  />
  
  <!-- Dropdown -->
  <ul
    class="absolute z-10 bg-gray-100 border w-full max-h-40 overflow-auto rounded-lg"
    *ngIf="showDropdown && filteredItems.length > 0"
  >
    <li
      *ngFor="let item of filteredItems"
      (mousedown)="selectItem(item)"
      class="cursor-pointer p-2 hover:bg-gray-200"
    >
      {{ item }}
    </li>
  </ul>
</div>